import { View } from "./View";

export interface IViewProps {
  currencySymbol: string;
  amount: string;
  fontSize?: number;
}

export const CurrencyDisplay = (props: IViewProps) => {
  return <View {...props} />;
};
